export default {
    UNSET: 'UNSET',
    LOADING: 'LOADING',
    KID: 'KID',
    EXISTED: 'EXISTED',
    NEWUSER: 'NEWUSER',
    USERCANTBEADDED: 'USERCANTBEADDED',
    ERROR: 'ERROR'        
}